import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import DateUtils from 'src/app/utils/date';

@Component({
  selector: 'app-custom-date-range-filter',
  templateUrl: './custom-date-range-filter.component.html',
  styleUrls: ['./custom-date-range-filter.component.css']
})
export class CustomDateRangeFilterComponent implements OnInit {
  dateUtil = new DateUtils;
  @Input() dateRange: { startDate: any, endDate: any };
  @Output() dateChange = new EventEmitter();
  @Input() dateType = '90';

  constructor() { }

  ngOnInit() { };
  SelectFilterChange() {
    this.updateDateRange();
    if (this.dateType != 'custom-range') {
      const startDate = this.dateUtil.getTsByNum(Number(this.dateType))
      const endDate = new Date().getTime();
      this.dateChange.emit({ dateRange: { startDate, endDate }, dateType: this.dateType });
    }
  }

  dateFilterChanged() {
    this.dateChange.emit({ dateRange: { ...this.dateRange }, dateType: this.dateType });
  }
  updateDateRange() {
    if (this.dateRange) {
      const { startDate, endDate } = this.dateRange;
      const { getShortDate } = this.dateUtil;
      this.dateRange = { startDate: getShortDate(startDate), endDate: getShortDate(endDate) }
    }
  }

}
